import { createFileRoute } from "@tanstack/react-router";
import { proveedoresAgrupadosQueryOptions } from "@/features/proveedor/hooks/use-proveedores-agrupados";
import { ProveedorPage } from "@/features/proveedor/components/ProveedorPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/proveedor` · file delgado con loader que
 * precarga la solicitud y los grupos de proveedores en paralelo.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/proveedor")({
  loader: ({ context: { queryClient }, params: { id } }) => Promise.all([queryClient.ensureQueryData(solicitudQueryOptions(id)), queryClient.ensureQueryData(proveedoresAgrupadosQueryOptions(id))]),
  component: ProveedorPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
